import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { addNewSearch } from 'utils/utils';
import { SearchRangePicker } from 'components/atoms';
import moment, { Moment } from 'moment';
import 'components/TableSearchBox/index.scss';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';

const cx = classNames.bind('./index.scss');

export interface MailingSearchBoxProp {}

const MailingSearchBox = ({}: MailingSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchRange, setSearchRange] = useState<RangeValue<Moment>|null>();
  const [searchDateStart, setSearchDateStart] = useState<string>();
  const [searchDateEnd, setSearchDateEnd] = useState<string>();
  
  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchDateStart('');
    setSearchDateEnd('');
    setSearchRange(null);
    navigate(location.pathname);
  };

  const onSearch = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { search: value, searchDateStart: searchDateStart, searchDateEnd: searchDateEnd, pageNo: 1 }),
    });    
  };

  const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
    setSearchRange(date);

    const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYYMMDD') : '';
    const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYYMMDD') : '';

    setSearchDateStart(searchDateS);
    setSearchDateEnd(searchDateE);

    navigate({
      ...location,
      search: addNewSearch(location.search, { search: searchInput, searchDateStart: searchDateS, searchDateEnd: searchDateE, pageNo: 1 }),
    });   
  };

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const historySearch = getQueryString(location.search);
    if (historySearch.search) setSearchInput(historySearch.search);
    if (historySearch.searchDateStart && historySearch.searchDateEnd) {
      setSearchDateStart(historySearch.searchDateStart);
      setSearchDateEnd(historySearch.searchDateEnd);
      setSearchRange([moment(historySearch.searchDateStart, "YYYY-MM-DD"), moment(historySearch.searchDateEnd, "YYYY-MM-DD")]);
    } else {
      setSearchRange(null);
    }   
    
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space>   
        <SearchRangePicker value={searchRange} format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} /> 
        <Input.Search
          className={cx('searchInput')}
          value={searchInput}
          placeholder="기업명 혹은 이름을 입력해 주세요"
          onChange={onChange}
          onSearch={onSearch}
          allowClear
        />
        <Button onClick={onClickReset}>
          검색초기화
        </Button>                
      </Space>
    </div>
  );
};

export default MailingSearchBox;
